'use strict';

// eslint-disable-next-line require-jsdoc
function printDiv(divId, title) {
    let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    mywindow.document.write(`<html><head><title>${title}</title>`);
    mywindow.document.write('<link rel="stylesheet" href="/on/demandware.static/Sites-UrbanElectricCo-Site/-/default/v1665079706081/css/priceListPrint.css" type="text/css" />');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<div id="UECoLogo">' + document.getElementById('UECoLogo').innerHTML + '</div>');

    mywindow.document.write(document.getElementById(divId).innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    setTimeout(function () { mywindow.print(); }, 1400);
    setTimeout(function () { mywindow.close(); }, 1450);

    return true;
}

// eslint-disable-next-line require-jsdoc
function isNumeric(str) {
    if (typeof str !== 'string') return false; // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
           !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
}

jQuery.fn.sortElements = (() => {
    var sort = [].sort;
    return function (comparator, getSortable) {
        // eslint-disable-next-line no-param-reassign
        getSortable = getSortable || function () { return this; };

        var placements = this.map(function () {
            var sortElement = getSortable.call(this),
                parentNode = sortElement.parentNode,
                // Since the element itself will change position, we have
                // to have some way of storing it's original position in
                // the DOM. The easiest way is to have a 'flag' node:
                nextSibling = parentNode.insertBefore(
                    document.createTextNode(''),
                    sortElement.nextSibling
                );

            return function () {
                if (parentNode === this) {
                    throw new Error(
                        "You can't sort elements if any one is a descendant of another."
                    );
                }

                // Insert before flag:
                parentNode.insertBefore(this, nextSibling);
                // Remove flag:
                parentNode.removeChild(nextSibling);
            };
        });

        return sort.call(this, comparator).each(function (i) {
            placements[i].call(getSortable.call(this));
        });
    };
})();

$(document).ready(function () {
    var box = document.querySelector('.orders-tbody');
    var scrollbarWidth = (box.offsetWidth - box.clientWidth).toString() + 'px';
    var root = document.documentElement;
    var cssName = '--scroll_bar_width';
    root.style.setProperty(
        cssName, scrollbarWidth
    );

    var minWidthName = '--description-min-width';
    var minWidthVal = ($('.orders-tbody').width() * 0.28) + 'px';
    root.style.setProperty(
        minWidthName, minWidthVal
    );

    $('.clickable-row').click(function () {
        window.location = $(this).data('href');
    });

    $('.pricelist-print-button').on('click', function () {
        var divId = 'maincontent';
        var title = 'Urban Electric Price List';
        printDiv(divId, title);
        // generatePdf();
    });

    var table = $('.pricelist-container table');

    $('.pricelist-container th')
        .wrapInner('<span title="sort this column"/>')
        .each(function () {
            var th = $(this),
                thIndex = th.index(),
                inverse = false;

            th.click(function () {
                table.find('td').filter(function () {
                    return $(this).index() === thIndex;
                }).sortElements(function (a, b) {
                    var valA = $.text([a]);
                    var valB = $.text([b]);

                    if (valA.indexOf('$') > -1) {
                        valA = valA.replace(/\D/g, '');
                        valB = valB.replace(/\D/g, '');
                    }

                    if (isNumeric(valA)) {
                        valA = parseInt(valA);
                        valB = parseInt(valB);
                    }

                    if (valA === valB) {
                        var descriptionTextA = $(a).parent().find('.table-cell').first()
                            .text();
                        var descriptionTextB = $(b).parent().find('.table-cell').first()
                            .text();

                        if (descriptionTextA === descriptionTextB) return 0;

                        // eslint-disable-next-line no-nested-ternary
                        return descriptionTextA > descriptionTextB ? 1 : -1;
                    }

                    // eslint-disable-next-line no-nested-ternary
                    return valA > valB ? inverse ? -1 : 1 : inverse ? 1 : -1;
                }, function () {
                // parentNode is the element we want to move
                    return this.parentNode;
                });

                inverse = !inverse;
            });
        });

    $('#productSearchForm').on('submit', function (e) {
        e.preventDefault();
    });

    var $rows = $('table tbody tr');
    $('.order-search-input').on('keyup', function () {
        var val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase();

        $rows.show().filter(function () {
            var text = $(this).text().replace(/\s+/g, ' ').toLowerCase();
            return !~text.indexOf(val);
        }).hide();
    });

    $('.icon-search').on('click', function () {
        $('.order-search-input').focus();
        $('.pricelist-search-icon').addClass('d-none');
    });

    $('.order-search-input').on('focus', function () {
        $('.pricelist-search-icon').addClass('d-none');
    });

    $('.order-search-input').on('blur', function () {
        if (!this.value) {
            $('.pricelist-search-icon').removeClass('d-none');
        }
    });
});
